import { render, staticRenderFns } from "./InsurancePolicyView.vue?vue&type=template&id=3a3d6436&"
import script from "./InsurancePolicyView.vue?vue&type=script&lang=js&"
export * from "./InsurancePolicyView.vue?vue&type=script&lang=js&"
import style0 from "./InsurancePolicyView.vue?vue&type=style&index=0&id=3a3d6436&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports